<template>
  <div>
    <!-- Container-fluid starts-->
    <div class="container">
      <Breadcrumbs :title="$t('addOnPage.irktimNLavlr')" />

      <h4>{{ $t('addOnPage.irktimNLavlr') }}</h4>
      <div v-if="company.format === 'PERSONAL'">
        <div class="alert alert-info">
          {{ $t('addOnPage.irktlrNOlanPaketlrFrdiXslrTrfindnAktivldirilBilmz') }}
        </div>
      </div>
      <div v-else-if="!hasAdmin">
        <div class="card">
          <div class="card-body">
            {{ $t('addOnPage.irktNLavniAktivldirmkNIrktinizinRhbriOlmalsnz') }}
            <router-link :to="{name: 'page', params: {slug: 'admin_guide'}}">
              {{ $t('addOnPage.adminOlmaqNMracitEt') }}
            </router-link>
          </div>
        </div>
      </div>
      <div v-else-if="!isAdmin">
        <div class="card">
          <div class="card-body">
            {{ $t('addOnPage.irktNLavniAncaqIrktAdminiAktivldirBilr') }}
          </div>
        </div>
      </div>
      <div
        v-else
        class="row mt-4"
      >
        <div class="col-lg-8">
          <div v-if="myPackage !== null && !showPackages">
            <div class="card">
              <div class="card-body">
                <h4>{{ myPackage.pack.name }}</h4>
                <div>{{ myPackage.pack.description }}</div>
                <div>
                  <strong>{{ $t('addOnPage.bitmTarixi') }} </strong>
                  <span>{{getMoment(myPackage.expirationTime)}}</span>
                </div>

                <div v-if="['ACTIVE','EXPIRED'].indexOf(myPackage.status)>-1">
                  <hr>
                  <button
                    v-if="myPackage.card === null"
                    class="btn btn-light-primary"
                    @click.prevent="addCard"
                  >
                    {{ $t('addOnPage.yenilnmNKartLavEt') }}
                  </button>
                  <div v-else>
                    <p>
                      {{ getMoment(myPackage.expirationTime)}}
                    </p>

                    <button class="btn btn-light-dark d-inline-flex align-items-center">
                      <feather
                        type="credit-card"
                        class="mr-2"
                      />
                      {{ myPackage.card.pan }}
                    </button>
                    <button
                      class="btn btn-sm btn-light-warning ml-3"
                      @click.prevent="addCard"
                    >
                      <i class="fa fa-pencil" />
                      {{ $t('addOnPage.kartDyi') }}
                    </button>
                  </div>
                </div>
                <hr>

                <button
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="showPackages=true"
                >
                  {{ $t('addOnPage.paketimiDyi') }}
                </button>

                <button
                  v-if="myPackage.status==='ACTIVE' || myPackage.status==='EXPIRED' "
                  class="btn btn-sm btn-light-danger ml-1"
                  @click.prevent="cancelPackage"
                >
                  {{ $t('addOnPage.paketiLvEt') }}
                </button>

                <button
                  v-if="myPackage.status==='CANCELED' "
                  class="btn btn-sm btn-light-success ml-1"
                  @click.prevent="reactivatePackage"
                >
                  {{ $t('addOnPage.paketiYenidnAktivldir') }}
                </button>
              </div>
            </div>
          </div>


          <div v-else>
            <div
              v-if="packageList.length<1"
              class="card"
            >
              <div class="card-body">
                {{ $t('addOnPage.buProfilNAktivLavMvcudDeyil') }}
              </div>
            </div>

            <div
              v-for="p in packageList"
              class="card"
            >
              <div class="card-body">
                <h4>{{ p.package.name }}</h4>
                <p>{{ p.package.description }}</p>

                <button
                  class="btn btn-sm btn-light-primary"
                  @click.prevent="selectPackage(p)"
                >
                  <span v-if="myPackage!=null && myPackage.pack.id === p.package.id">
                    {{ $t('addOnPage.mddtiDyi') }}
                  </span>
                  <span v-else>{{ $t('addOnPage.paketiAktivldir') }}</span>
                </button>
              </div>
            </div>

            <div
              v-if="myPackage!=null"
              class="mb-4"
            >
              <button
                class="btn btn-sm btn-outline-primary"
                @click.prevent="showPackages = false"
              >
                {{ $t('addOnPage.aktivPaketim') }}
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="company"
          class="col-lg-4"
        >
          <div class="card">
            <div class="card-body">
              <div class="media align-items-center">
                <img
                  class="rounded-circle user-image border mr-2"
                  :src="getPhoto(company.logo,'thumbnailCropped')"
                  alt=""
                  style="width: 60px"
                >
                <div class="about">
                  <div class="name f-w-600">
                    {{ company.name }} {{ getCompanyFormat(company.format) }}
                  </div>
                  <div class="status">
                    {{ company.taxId }}
                  </div>
                </div>
              </div>

              <p class="mt-2">
                {{ $t('dashboardActiveCompanyCard.sizHazrdaIrktind', {name: company.name, getCompanyFormat: getCompanyFormat(company.format)}) }}
                <strong> {{ getProfileName(profile) }} </strong> {{ $t('dashboardActiveCompanyCard.profilid') }} <strong>{{ position }}</strong>
                {{ $t('dashboardActiveCompanyCard.vzifsindFaliyytGstrirsiniz') }}
              </p>
            </div>
          </div>
        </div>
      </div>


      <div
        v-if="page && packageList.length>0 "
        class="row"
      >
        <div class="col-md-8">
          <div class="card">
            <img
              v-if="page.banner"
              class="card-img-top"
              :src="getPhoto(page.banner,'')"
              alt=""
            >
            <div class="card-body">
              <h4>{{ page.title }}</h4>

              <div
                class="pageText"
                v-html="page.text"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4" />
      </div>
    </div>
    <!-- Container-fluid Ends-->

    <b-modal
      id="modal-periods"
      ref="periods"
      centered
      :title="$t('addOnPage.paketSeimi')"
      :hide-header="true"
      :ok-disabled="selectedPeriod === null || packageTerms<1"
      ok-title="Aktivləşdir"
      cancel-title="Ləğv et"
      class="theme-modal"
      @ok="activatePackage(selectedPeriod)"
    >
      <div v-if="selectedPackage">
        <h4>{{ selectedPackage.package.name }}</h4>
        <div
          v-for="p in selectedPackage.periods"
          :key="p.id"
          @click.prevent="selectedPeriod = p"
        >
          <PackagePeriodItem
            :period="p"
            :pack="selectedPackage.package"
            :selected=" selectedPeriod && p.id === selectedPeriod.id"
            :trial-used="trialUsed"
          />
        </div>

        <div v-if="selectedPeriod">
          <div class="checkbox checkbox-success  ml-1 mb-3">
            <b-form-checkbox
              v-model="packageTerms"
              value="1"
              required
            >
              <router-link
                target="_blank"
                :to="{path: '/dashboard/page/addon_terms'}"
              >
                {{ $t('addOnPage.dniRtVQaydalarnQbulEdirm') }}
              </router-link>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {
  activateAddon,
  cancelAddOn,
  getPackages, getPage, reactivateAddOn,
} from "@/repositories/GeneralDataRepository";
import {mediaBase, paymentDomain} from "@/repositories/Repository";
import {buildLongId, getCompanyFormat, getPhoto, getProfileName} from "@/repositories/Utils";
import PackagePeriodItem from "@/pages/scc/package/PackagePeriodItem.vue";
import {handleErrors} from "@/repositories/VendorManagementRepository";
import moment from "moment/moment";


export default {
  components: {PackagePeriodItem},
  data() {
    return {
      mediaBase: mediaBase,
      paymentDomain: paymentDomain,
      packageList: [],
      myPackage: null,
      showPackages: false,
      trialUsed: true,
      selectedPackage: null,
      selectedPeriod: null,
      packageTerms: 0,
      page: null
    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
      sessionType: state => state.auth.sessionType,
      profile: state => state.auth.profile,
      position: state => state.auth.position,
      hasAdmin: state => state.auth.hasAdmin,
      isAdmin: state => state.auth.isAdmin,

    }),


  },
  mounted() {

    this.getPackageList();
    this.getPage();

  },
  methods: {
    getMoment(time) {
      moment.locale(this.$i18n.locale);
      return moment(new Date(time)).format('DD MMM YYYY HH:mm')
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },
    getProfileName(keyword) {
      return getProfileName(keyword,this.i18n);
    },
    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },

    buildLongId(id) {
      return buildLongId(id, 5);
    },
    getPackageList() {
      getPackages(this.token, 'addon').then(data => {
        if (data.code === 200) {
          this.packageList = data.packages;
          this.trialUsed = data.trialUsed;
          this.myPackage = data.activePackage;
        } else {
          handleErrors(this.$swal, data, null);
        }
      })
    },

    activatePackage(period) {

      if (period != null) {

        if (this.packageTerms > 0) {

          if (this.isAdmin) {
            activateAddon(this.token, period).then(data => {
              if (data.code === 200) {
                window.location.href = this.paymentDomain + '/invoice.php?invoice=' + data.id
              } else {
                handleErrors(this.$swal, data, null);
              }
            });
          } else {
            this.$swal({
              title: this.$t("generalModal.warningTitle"),
              text: this.$t("sznVendorMngmntLvns"),
              icon: 'warning'
            }).then(() => {
              this.$router.push("/dashboard/company/profile");
            });
          }
        } else {
          this.$refs.periods.show();
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("odnsSrtQydlrQbl"),
            icon: 'error'
          });
        }
      }
    },

    cancelPackage() {
      this.$swal.fire({
        title: this.$t("generalModal.warningTitle"),
        text: this.$t("szAbnlyDyndrdqSnraSechdiyiniz"),
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: this.$t("newPolRequest.xeyr"),
        confirmButtonText: this.$t("newPolRequest.bli"),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',

      }).then((result) => {
        if (result.isConfirmed) {
          cancelAddOn(this.token).then(data => {
            if (data.code === 200) {
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("abunlynzDyndrld"),
                icon: 'success'
              })
              this.getPackageList();
            } else {
              handleErrors(this.$swal, data, null);
            }
          });
        }
      })

    }, reactivatePackage() {
      if (confirm(this.$t("abunlynzDvmEtdrmkIs"))) {
        reactivateAddOn(this.token).then(data => {
          if (data.code === 200) {
            this.$swal({
              title: this.$t("generalModal.successTitle"),
              text: this.$t("abnlynzDvmEtdrl"),
              icon: 'success'
            })
            this.getPackageList();
          } else {
            handleErrors(this.$swal, data, null);
          }
        });
      }
    },
    addCard() {
      window.location.href = this.paymentDomain + '/saveCardCompany.php?companyPackageId=' + this.myPackage.id
    },

    selectPackage(pack) {
      this.selectedPackage = pack;
      this.selectedPeriod = null;
      this.packageTerms = 0;
      this.$refs.periods.show();
    },

    getPage() {
      getPage(this.token, 'addon_description').then(data => {
        if (data.code === 200) {
          this.page = data.data;
        }
      })
    }
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

.ql-video {
  width: 100%;
  height: 400px;
}

.pageText img {
  max-width: 100%;
  height: auto;
}

</style>
